import logout from './logout';
import sendPasswordResetTokens from './send-password-reset-tokens';
import resetPassword from './reset-password';
import verifyConfirmationToken from './verify-confirmation-token';
import sendVerificationEmail from './send-verification-email';

export default {
  logout,
  sendPasswordResetTokens,
  resetPassword,
  verifyConfirmationToken,
  sendVerificationEmail,
};
